import { IconWrapper } from '../runtime';
export default IconWrapper('toggle', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M5 9.49969H11L9.5 10.7497M11 6.49969H5L6.5 5.24969M1.75 12.7497V3.24969C1.75 2.42127 2.42157 1.74969 3.25 1.74969H12.75C13.5784 1.74969 14.25 2.42127 14.25 3.24969V12.7497C14.25 13.5781 13.5784 14.2497 12.75 14.2497H3.25C2.42157 14.2497 1.75 13.5781 1.75 12.7497Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});